<template>
  <div></div>
</template>

<script>
export default {
  name: "",
  data() {
    return {};
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue